import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const KpiBarChart = ({ data, title, color = '#007bff' }) => {
  // Format the data to match preview styling
  const formattedData = {
    ...data,
    datasets: data.datasets?.map((dataset, index) => ({
      ...dataset,
      backgroundColor: dataset.backgroundColor || 
                      dataset.seriesColor ? dataset.seriesColor + '20' : 
                      color + '20', // Add transparency
      borderColor: dataset.borderColor || 
                   dataset.seriesColor || 
                   color,
      borderWidth: dataset.borderWidth || 2,
    })) || []
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: !!title,
        text: title,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div style={{ height: '300px', width: '100%' }}>
      <Bar data={formattedData} options={options} />
    </div>
  );
};

export default KpiBarChart;
